"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experiments = void 0;
const host_modules_1 = require("@wix/sdk-runtime/host-modules");
/** @internal */
exports.experiments = (0, host_modules_1.createHostModule)({
    enabled: (host) => (key) => {
        if (!host.getExperiments) {
            throw new Error('Host "Experiments" are not available on the current host. Make sure to use an updated version of the host initialization pacakge.');
        }
        return host.getExperiments().enabled(key);
    },
    get: (host) => (key) => {
        if (!host.getExperiments) {
            throw new Error('Host "Experiments" are not available on the current host. Make sure to use an updated version of the host initialization pacakge.');
        }
        return host.getExperiments().get(key);
    },
});
